module.exports = __webpack_public_path__ + "img/19.719733c3.jpeg";